module.exports = __webpack_public_path__ + "img/text-and-image-row-left.7dcbc52f.svg";